<template>
	<div class="Catalog" ref="userinfo">
		<loginheader flagg="1" num="6"></loginheader>
		<div class="Catalog-bg">
			<img :src="info.detail_pic" alt class="Catalog-img" />
		</div>
		<div class="Catalog-concent">
			<div class="Catalog-con">
				<div class="Catalog-con-left">
					<div class="Catalog-con-left-head">
						<img :src="info.cover_pic" alt class="Catalog-con-left-head-left" />
						<div class="Catalog-con-left-head-right">
							<p class="Catalog-myp">{{info.title}}</p>
							<div class="Catalog-mydiv">
								<p class="Catalog-myp1" v-for="(item, index) in bookcate" :key="index">{{item}}</p>
							</div>
							<p class="Catalog-myp3">更新至{{info.update_time}}</p>
							<p class="Catalog-myp4" v-if="info.status==1">连载中</p>
							<p class="Catalog-myp5" v-if="info.status==2">已完结</p>
							<div class="Catalog-mydiv1">
								<!-- <router-link to="/particulars"> -->
								<button type="button" class="Catalog-btn" @click="read()">开始阅读</button>
								<Collection type="paint" :id="this.$route.query.id" :state="cartoon.collect"></Collection>
							</div>
						</div>
					</div>
					<div class="Catalog-mydiv2">
						<el-tabs v-model="activeName" @tab-click="handleClick()">
							<el-tab-pane label="作品信息" name="first">
								<div class="Catalog-xxk-div">
									<p class="Catalog-xxk-div-p">简介:</p>
									<p class="Catalog-xxk-div-p1">{{info.summary}}</p>
									<p class="Catalog-xxk-div-p2">最近更新:</p>
									<div class="Catalog-xxk-div-div">
										<div class="Catalog-xxk-div-div-div" v-for="(item, index) in episodes" :key="index">
											<p class="Catalog-xxk-div-p3" @click="read()">{{item.title}}</p>
											<p class="Catalog-xxk-div-p4">{{item.update_time_text}}</p>
										</div>
									</div>
								</div>
								<publiclogin></publiclogin>
								<Comment :comment="comment" :id="id" type="paint"></Comment>
							</el-tab-pane>
							<el-tab-pane :label="'目录('+episodes.length+'章)'" name="second">
								<div>
									<div class="second-div">
										<p
											class="second-div-p"
											v-for="(item, index) in episodes"
											:key="index"
											@click="read()"
										>{{item.title}}</p>
									</div>
									<div class="second-div1" v-if="episodes.length>3">
										<p>查看全部目录</p>
										<img src="../../img/xiala.png" alt />
									</div>
								</div>
								<publiclogin></publiclogin>
							</el-tab-pane>
							<el-tab-pane label="讨论" name="third">
								<publiclogin></publiclogin>
								<Comment :comment="comment" :id="id" type="paint"></Comment>
							</el-tab-pane>
						</el-tabs>
					</div>
					<Backtop></Backtop>
				</div>

				<div class="Catalog-con-right">
					<div class="Catalog-con-right-head">
						<img src="../../img/portrait.png" alt class="portrait" />
						<p class="Catalog-Nickname">{{info.publish_name}}</p>
						<p class="Catalog-autograph">{{info.publish_bio}}</p>
						<follow :follow="cartoon.follow" :id="info.publish"></follow>
					</div>
					<div class="Catalog-con-right-cen">
						<img :src="advert" alt class="Catalog-con-right-cen-img" />
						<p class="advert">广告</p>
					</div>
					<div class="Catalog-con-right-foot">
						<p class="Catalog-con-right-foot-p">其他推荐</p>
						<div class="tuijian-div" v-for="(item, index) in recomCartoon" :key="index">
							<span class="Catalog-con-right-foot-p1">[{{item.bookcate[0]}}]</span>
							<p class="Catalog-con-right-foot-p2" @click="toCartooninfo(item.id)">{{item.title}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Fotter></Fotter>
	</div>
</template>

<script>
	import Fotter from "../Fotter.vue";
	import loginheader from "../loginheader.vue";
	import publicmulu from "../publicmulu.vue";
	import Comment from "../Comment.vue";
	import Backtop from "../Backtop.vue";
	import publiclogin from "../publiclogin.vue";
	import Collection from "../Collection.vue";
	import follow from "../follow.vue";
	export default {
		name: "App",
		components: {
			Fotter,
			loginheader,
			Comment,
			publicmulu,
			Backtop,
			publiclogin,
			Collection,
			follow
		},
		data() {
			return {
				activeName: "first",
				btnFlag: false,
				bookcate: "",
				info: "",
				episodes: "",
				advert: "",
				recomCartoon: "",
				comment: "",
				id: "",
				cartoon: ""
			};
		},
		methods: {
			handleClick(tab, event) {},
			read() {
				this.$router.push({
					path: "/particulars",
					query: { id: this.info.id }
				});
			},
			getinfo() {
				this.$http.get("Cartoon/info/" + this.$route.query.id).then(res => {
					console.log("datalist", res.body.data);
					this.info = res.body.data.info;
				});
			},
			getFpage(page, size = 1) {
				this.$http
					.get(
						`comment/show/book/${this.$route.query.id}?page=${page}&size=${size}`
					)
					.then(res => {
						this.comment = res.body.msg;
					});
			},
			getCpage(page, size = 1, child, childSize = 1) {
				this.$http
					.get(
						`comment/show/book/${this.$route.query.id}?page=${page}&size=${size}&page=${child}&size=${childSize}`
					)
					.then(res => {
						this.comment = res.body.msg;
					});
			},
			// 漫画
			getcartoon() {
				this.$http.get("Cartoon/info/" + this.$route.query.id).then(res => {
					console.log("datalist", res.body.data);
					this.cartoon = res.body.data;
					this.info = res.body.data.info;
					this.bookcate = res.body.data.info.bookcate;
					this.episodes = res.body.data.info.episodes;
					this.advert = res.body.data.advert[0].image;
					this.recomCartoon = res.body.data.recomCartoon;
					console.log(this.cartoon);
				});
			},
			toCartooninfo(id) {
				const InfoDetail = this.$router.resolve({
					name: "Catalog",
					query: { id: id }
				});
				window.open(InfoDetail.href, "_blank");
			}
		},
		created() {
			this.getcartoon();
			// 评论
			this.$http
				.get(`comment/show/paint/${this.$route.query.id}?page=1&size=1`)
				.then(res => {
					console.log("评论 :", res);
					this.comment = res.body.msg;
				});
			this.id = this.$route.query.id;
		}
	};
</script>
<style>
	.goto {
		width: 70px;
		height: 70px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.2);
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		bottom: 450px;
		right: 200px;
		z-index: 100;
	}

	.go-top {
		width: 26px;
		height: 30px;
	}

	/* 选项卡 */
	.el-tabs__nav-scroll {
		display: flex;
		justify-content: center;
		margin-top: 40px !important;
		color: #28a3b1;
	}

	.el-tabs__item {
		color: #cccccc;
	}

	.el-tabs__item:hover {
		color: #28a3b1;
	}

	.el-tabs__active-bar {
		background-color: #28a3b1;
	}

	.el-tabs__item.is-active {
		color: #28a3b1;
	}

	.Catalog-xxk-div {
		height: 305px;
		padding: 20px 0;
		box-sizing: border-box;
	}

	.Catalog-xxk-div-p {
		font-size: 16px;
		color: #212121;
		font-weight: bold;
	}

	.Catalog-xxk-div-p1 {
		margin-top: 16px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 6;
		overflow: hidden;
		font-size: 14px;
	}

	.Catalog-xxk-div-p2 {
		font-size: 16px;
		margin-top: 30px;
		font-weight: bold;
	}

	.Catalog-xxk-div-div {
		display: flex;
		margin-top: 16px;
		flex-wrap: wrap;
	}

	.Catalog-xxk-div-div-div {
		display: flex;
		margin-right: 60px;
	}

	.Catalog-xxk-div-p3 {
		font-size: 14px;
		margin-right: 20px;
		cursor: pointer;
	}

	.Catalog-xxk-div-p4 {
		color: #808080;
		font-size: 12px;
	}

	.Catalog-xxl-foot {
		height: 160px;
		box-sizing: border-box;
		border: 1px solid #cccccc;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.Catalog-xxl-foot-div-img {
		width: 44px;
		height: 44px;
		margin: 0 auto;
	}

	.Catalog-xxk-mydiv {
		display: flex;
		margin-top: 16px;
	}

	.Catalog-xxk-mydiv-p {
		font-size: 14px;
		color: #28a3b1;
	}

	.Catalog-xxk-mydiv-p1 {
		font-size: 14px;
	}

	.Catalog-mydiv2 {
		background-color: #f5f5f5;
	}
</style>
<style scoped="scoped">
	.second-div1 {
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 30px;
	}

	.second-div1 p {
		font-size: 14px;
	}

	.second-div1 img {
		width: 12px;
		height: 6px;
		margin-left: 5px;
	}

	.second-img {
		width: 24px;
		height: 24px;
		margin-left: 10px;
	}

	.second-div-p {
		width: 33.333%;
		font-size: 14px;
		line-height: 24px;
		margin-bottom: 10px;
		display: flex;
	}

	.second-div {
		width: 100%;
		padding: 20px 0;
		display: flex;
		flex-wrap: wrap;
	}

	.Catalog {
		position: relative;
	}

	.Catalog-bg {
		width: 100%;
		height: 300px;
		position: absolute;
		top: 40px;
	}

	.Catalog-img {
		width: 100%;
		height: 300px;
	}

	.Catalog-concent {
		margin-top: 220px;
		width: 100%;
		display: flex;
		justify-content: center;
		background-color: #f5f5f5;
	}

	.Catalog-con {
		width: 1200px;
		height: auto;
		z-index: 100;
		display: flex;
		margin-bottom: 40px;
	}

	.Catalog-con-left {
		width: 920px;
		background-color: #f5f5f5;
		border-radius: 8px;
		margin-right: 40px;
	}

	.Catalog-con-left-head {
		width: 920px;
		height: 330px;
		border-radius: 8px;
		background-color: #fff;
		padding: 24px;
		display: flex;
		border: 1px solid #cccccc;
		box-sizing: border-box;
	}

	.Catalog-con-left-head-left {
		width: 160px;
		height: 220px;
		margin-right: 24px;
		border-radius: 6px;
	}

	.Catalog-myp {
		font-size: 30px;
		color: #212121;
		font-weight: bold;
	}

	.Catalog-mydiv {
		margin-top: 16px;
		display: flex;
	}

	.Catalog-myp1 {
		padding: 3px 10px;
		border: 1px solid #808080;
		margin-right: 10px;
		font-size: 12px;
		border-radius: 13px;
		color: #808080;
		height: 16px;
		line-height: 16px;
	}

	.Catalog-myp2 {
		font-size: 14px;
		margin-top: 10px;
		height: 24px;
	}

	.Catalog-myp3 {
		margin-top: 16px;
		font-size: 12px;
	}

	.Catalog-myp4 {
		margin-top: 16px;
		font-size: 14px;
		color: #d52e25;
	}
	.Catalog-myp5 {
		margin-top: 16px;
		font-size: 14px;
		color: #212121;
	}

	.Catalog-mydiv1 {
		display: flex;
		margin-top: 68px;
	}

	.Catalog-btn {
		width: 120px;
		height: 40px;
		border: 0;
		border-radius: 6px;
		background-color: #28a3b1;
		color: #fff;
		margin-right: 16px;
	}

	.Catalog-btn1 {
		width: 120px;
		height: 40px;
		border: 1px solid #b3b3b3;
		border-radius: 6px;
		background-color: #fff;
		color: #212121;
		margin-right: 16px;
	}

	.Catalog-con-right-head {
		width: 240px;
		height: 278px;
		background-color: #ffffff;
		box-sizing: border-box;
		border: 1px solid #cccccc;
		border-radius: 8px;
		padding: 20px;
	}

	.portrait {
		width: 60px;
		height: 60px;
		margin: 0 auto;
	}

	.Catalog-Nickname {
		font-size: 16px;
		width: 107px;
		margin: 16px auto 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
	}

	.Catalog-autograph {
		width: 150px;
		font-size: 12px;
		margin: 0 auto;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
		text-align: center;
	}

	.Catalog-con-right-cen-img {
		width: 240px;
		height: 300px;
	}

	.Catalog-con-right-cen {
		width: 240px;
		height: 300px;
		margin-top: 10px;
		position: relative;
	}

	.advert {
		width: 34px;
		height: 16px;
		background: rgba(179, 179, 179, 1);
		text-align: center;
		color: #fff;
		font-size: 12px;
		position: absolute;
		bottom: 12px;
		right: 12px;
	}

	.Catalog-con-right-foot {
		width: 240px;
		height: 310px;
		border-radius: 8px;
		box-sizing: border-box;
		border: 1px solid #cccccc;
		margin-top: 10px;
		padding: 12px;
		background-color: #fff;
	}

	.Catalog-con-right-foot-p {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 8px;
	}

	.tuijian-div {
		display: flex;
		margin-top: 8px;
		cursor: pointer;
	}

	.Catalog-con-right-foot-p1 {
		font-size: 14px;
		margin-right: 12px;
	}

	.Catalog-con-right-foot-p2 {
		font-size: 14px;
		width: 135px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>



// WEBPACK FOOTER //
// src/components/Cartoon/Catalog.vue